import { createSlice } from '@reduxjs/toolkit';

type scrollYStateType = {
  homePageScrollY: number;
  infoListPageScrollY: number;
  productListPageScrollY: number;
  openMarketListPageScrollY: number;
  tractorPokingListPageScrollY: number;
  cropTrendsListPageScrollY: number;
  cropTrendsSelectedItem: {
    middleCategoryName: string;
    smallCategoryName?: string;
  } | null;

  event202402ScrollY: number;

  // 페이지별 스크롤 애니메이션 실행 여부
  scrollAnimationExecuted: {
    [pathname: string]: boolean;
  };

  // 브랜드 스크롤 애니메이션 실행 여부 (서버 데이터 로딩 타이밍이 다름)
  brandScrollAnimationExecuted: {
    [pathname: string]: boolean;
  };
};

const initialState: scrollYStateType = {
  homePageScrollY: 0,
  infoListPageScrollY: 0,
  productListPageScrollY: 0,
  openMarketListPageScrollY: 0,
  tractorPokingListPageScrollY: 0,
  cropTrendsListPageScrollY: 0,
  cropTrendsSelectedItem: null,
  event202402ScrollY: 0,
  scrollAnimationExecuted: {},
  brandScrollAnimationExecuted: {},
};

export const scrollYSlice = createSlice({
  name: 'scrollY',
  initialState,
  reducers: {
    changeHomePageScrollY: (state, action) => {
      state.homePageScrollY = action.payload;
    },
    changeInfoListPageScrollY: (state, action) => {
      state.infoListPageScrollY = action.payload;
    },
    changeProductListPageScrollY: (state, action) => {
      state.productListPageScrollY = action.payload;
    },
    changeOpenMarketListPageScrollY: (state, action) => {
      state.openMarketListPageScrollY = action.payload;
    },
    changeTractorPokingListPageScrollY: (state, action) => {
      state.tractorPokingListPageScrollY = action.payload;
    },
    changeEvent202402ScrollY: (state, action) => {
      state.event202402ScrollY = action.payload;
    },
    changeCropTrendsListPageScrollY: (state, action) => {
      state.cropTrendsListPageScrollY = action.payload;
    },
    setCropTrendsSelectedItem: (state, action) => {
      state.cropTrendsSelectedItem = action.payload;
    },
    setScrollAnimationExecuted: (state, action) => {
      const { pathname, executed } = action.payload;
      state.scrollAnimationExecuted[pathname] = executed;
    },
    setBrandScrollAnimationExecuted: (state, action) => {
      const { pathname, executed } = action.payload;
      state.brandScrollAnimationExecuted[pathname] = executed;
    },
  },
});

export const {
  changeHomePageScrollY,
  changeInfoListPageScrollY,
  changeProductListPageScrollY,
  changeOpenMarketListPageScrollY,
  changeTractorPokingListPageScrollY,
  changeEvent202402ScrollY,
  changeCropTrendsListPageScrollY,
  setCropTrendsSelectedItem,
  setScrollAnimationExecuted,
  setBrandScrollAnimationExecuted,
} = scrollYSlice.actions;
